import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
    de: {
        translation: {
            "quality.unapproved": "Ungeprüft",
            "quality.self_declared": "Vom Betrieb geprüft",
            "quality.audited": "Von Fachorganisation geprüft",
            "map.logo": "Ginto öffnen",
            "map.reload_button": "Diesen Bereich durchsuchen",
            "map.locate_button": "Zum aktuellen Standort",
            "map.sidebar.collapse": "Suche schliessen",
            "map.sidebar.show_map": "Karte anzeigen",
            "map.sidebar.open_search": "Suche öffnen",
            "map.sidebar.open_results": "Ergebnisse anzeigen",
            "rating_profile_switcher.title": "Bedürfnisprofile",
            "rating_profile_switcher.label": "Bedürfnisprofil auswählen",
            "rating_profile_switcher.active": "aktiv",
            "rating_profile_switcher.no_profile": "Ohne Profil",
            "search_sidebar.search_sidebar.sidebar_title": "Suche",
            "search_sidebar.search_sidebar.field_title": "Suchmaske",
            "search_sidebar.search_sidebar.results_title": "Suchresultate",
            "search_sidebar.search_field.remove_search_tag": "Filter entfernen",
            "search_sidebar.search_field.label": "Suchbegriffe",
            "search_sidebar.search_field.placeholder": "Suchbegriff eingeben",
            "search_sidebar.autocomplete_list.text_query": "Nach \"{{queryText}}\" suchen",
            "search_sidebar.autocomplete_list.navigate": "Navigieren",
            "search_sidebar.autocomplete_list.select": "Auswählen",
            "search_sidebar.autocomplete_list.place_group_title": "Ortschaften",
            "search_sidebar.autocomplete_list.place_group_hint": "Tippen, um nach Ortschaften zu suchen",
            "search_sidebar.current_location_suggestion.text": "Mein Standort",
            "search_sidebar.extendable_list.show_more": "{{count}} weitere anzeigen",
            "search_sidebar.extendable_list.show_less": "Weniger anzeigen",
            "search_sidebar.search_result_list.hit_count": "{{count}} Ergebnisse",
            "search_sidebar.search_result_list.no_hits": "Keine Ergebnisse",
            "entry_tile.distance": "Entfernung:",
            "search_sidebar.error_message.title": "Es ist ein unerwarteter Fehler aufgetreten",
            "search_sidebar.error_message.body": "Bei der Serveranfrage ist ein Fehler aufgetreten. Bitte lade die Webseite neu und versuche es nochmals.",
        }
    },
    en: {
        translation: {
            "quality.unapproved": "Not verified",
            "quality.self_declared": "Verified by the business",
            "quality.audited": "Verified by specialist organization",
            "map.logo": "Open Ginto",
            "map.reload_button": "Search this area",
            "map.locate_button": "To the current location",
            "map.sidebar.collapse": "Close search",
            "map.sidebar.show_map": "Show map",
            "map.sidebar.open_search": "Open search",
            "map.sidebar.open_results": "Show results",
            "rating_profile_switcher.title": "Needs profiles",
            "rating_profile_switcher.label": "Select needs profile",
            "rating_profile_switcher.active": "active",
            "rating_profile_switcher.no_profile": "No Profile",
            "search_sidebar.search_sidebar.sidebar_title": "Search",
            "search_sidebar.search_sidebar.field_title": "Search mask",
            "search_sidebar.search_sidebar.results_title": "Search results",
            "search_sidebar.search_field.remove_search_tag": "Remove filter",
            "search_sidebar.search_field.label": "Search terms",
            "search_sidebar.search_field.placeholder": "Enter search term",
            "search_sidebar.autocomplete_list.text_query": "Search for \"{{queryText}}\"",
            "search_sidebar.autocomplete_list.navigate": "Navigate",
            "search_sidebar.autocomplete_list.select": "Select",
            "search_sidebar.autocomplete_list.place_group_title": "Places",
            "search_sidebar.autocomplete_list.place_group_hint": "Type to search for places",
            "search_sidebar.current_location_suggestion.text": "My location",
            "search_sidebar.extendable_list.show_more": "{{count}} show more",
            "search_sidebar.extendable_list.show_less": "Show less",
            "search_sidebar.search_result_list.hit_count": "{{count}} results",
            "search_sidebar.search_result_list.no_hits": "No results",
            "entry_tile.distance": "Distance:",
            "search_sidebar.error_message.title": "An unexpected error has occurred",
            "search_sidebar.error_message.body": "An error occurred during the server request. Please reload the website and try again.",
        }
    },
    fr: {
        translation: {
            "quality.unapproved": "Non vérifié",
            "quality.self_declared": "Vérifié par l'entreprise",
            "quality.audited": "Vérifié par une organisation professionnelle",
            "map.logo": "Ouvrir Ginto",
            "map.reload_button": "Rechercher dans cette section",
            "map.locate_button": "Vers l'emplacement actuel",
            "map.sidebar.collapse": "Fermer la recherche",
            "map.sidebar.show_map": "Afficher la carte",
            "map.sidebar.open_search": "Ouvrir la recherche",
            "map.sidebar.open_results": "Afficher les résultats",
            "rating_profile_switcher.title": "Profils des besoins",
            "rating_profile_switcher.label": "Sélectionner le profil de besoins",
            "rating_profile_switcher.active": "actif",
            "rating_profile_switcher.no_profile": "Sans profil",
            "search_sidebar.search_sidebar.sidebar_title": "Recherche",
            "search_sidebar.search_sidebar.field_title": "Masque de recherche",
            "search_sidebar.search_sidebar.results_title": "Résultats de la recherche",
            "search_sidebar.search_field.remove_search_tag": "Supprimer le filtre",
            "search_sidebar.search_field.label": "Termes de recherche",
            "search_sidebar.search_field.placeholder": "Saisir un terme de recherche",
            "search_sidebar.autocomplete_list.text_query": "Rechercher «{{queryText}}»",
            "search_sidebar.autocomplete_list.navigate": "Naviguer",
            "search_sidebar.autocomplete_list.select": "Sélectionner",
            "search_sidebar.autocomplete_list.place_group_title": "Localités",
            "search_sidebar.autocomplete_list.place_group_hint": "Tapez pour rechercher des localités",
            "search_sidebar.current_location_suggestion.text": "Ma localisation",
            "search_sidebar.extendable_list.show_more": "{{count}} en afficher d'autres",
            "search_sidebar.extendable_list.show_less": "Afficher moins",
            "search_sidebar.search_result_list.hit_count": "{{count}} résultats",
            "search_sidebar.search_result_list.no_hits": "Aucun résultat",
            "entry_tile.distance": "Distance :",
            "search_sidebar.error_message.title": "Une erreur inattendue s'est produite",
            "search_sidebar.error_message.body": "Une erreur est survenue lors de la demande au serveur. Veuillez recharger la page web et essayer à nouveau.",
        }
    },
    it: {
        translation: {
            "quality.unapproved": "Ungeprüft",
            "quality.self_declared": "Verificato dall'azienda",
            "quality.audited": "Verificato da un'organizzazione specializzata",
            "map.logo": "Apri Ginto",
            "map.reload_button": "Cerca in quest'area",
            "map.locate_button": "Alla posizione attuale",
            "map.sidebar.collapse": "Chiudi la ricerca",
            "map.sidebar.show_map": "Mostra la mappa",
            "map.sidebar.open_search": "Apri la ricerca",
            "map.sidebar.open_results": "Mostra i risultati",
            "rating_profile_switcher.title": "Profili di necessità",
            "rating_profile_switcher.label": "Selezionare il profilo di necessità",
            "rating_profile_switcher.active": "attivo",
            "rating_profile_switcher.no_profile": "Senza profilo",
            "search_sidebar.search_sidebar.sidebar_title": "Ricerca",
            "search_sidebar.search_sidebar.field_title": "Maschera di ricerca",
            "search_sidebar.search_sidebar.results_title": "Risultati della ricerca",
            "search_sidebar.search_field.remove_search_tag": "Rimuovere il filtro",
            "search_sidebar.search_field.label": "Termini di ricerca",
            "search_sidebar.search_field.placeholder": "Inserire il termine di ricerca",
            "search_sidebar.autocomplete_list.text_query": "Ricerca di \"{{queryText}}\"",
            "search_sidebar.autocomplete_list.navigate": "Navigare",
            "search_sidebar.autocomplete_list.select": "Selezionare",
            "search_sidebar.autocomplete_list.place_group_title": "Luoghi",
            "search_sidebar.autocomplete_list.place_group_hint": "Digitare per cercare i luoghi",
            "search_sidebar.current_location_suggestion.text": "La mia posizione",
            "search_sidebar.extendable_list.show_more": "{{count}} mostra di più",
            "search_sidebar.extendable_list.show_less": "Mostra meno",
            "search_sidebar.search_result_list.hit_count": "{{count}} risultati",
            "search_sidebar.search_result_list.no_hits": "Nessun risultato",
            "entry_tile.distance": "Distanza:",
            "search_sidebar.error_message.title": "Si è verificato un errore imprevisto",
            "search_sidebar.error_message.body": "Si è verificato un errore durante la richiesta al server. Ricaricare il sito e riprovare.",
        }
    }
};

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .use(LanguageDetector)
    .init({
        resources,
        supportedLngs: ["de", "en", "fr", "it"],
        fallbackLng: "en",
        detection: {
            order: ["htmlTag"]
        },
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;
